import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSelector, useDispatch } from 'react-redux';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        textAlign: 'center',
        color: '#ffffff'
    },
    rowRoot: {
        '& .MuiTableCell-root': {
            padding: 10
        }
    }
}));

function FMV(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })
    return(
        <TableContainer component={Paper}>
            <Table aria-label="fmv-table">
                <TableBody>
                    <TableRow className={ classes.rowRoot }>
                        <TableCell component="td" scope="row">Fair Market Value</TableCell>
                        <TableCell component="td" scope="row" align={ 'right' }>P{ `${ states.fmv ? states.fmv.toLocaleString() : 0 }` }</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default FMV;